import React from 'react';
import Banner from './Banner';
import { companies } from '../data/companies';

const Works = () => {
  const TimelineState = ({ state }) => {
    return (
      <div className="timeline-state py-4">
        <p className="text-lg md:text-xl lg:text-2xl text-primary">
          {state.date}
        </p>
        <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
          <p className="text-sm md:text-lg lg:text-xl font-bold">
            {state.content.text}
            <a
              href={state.content.linkHref}
              target="_blank"
              rel="noreferrer"
              className="text-primary"
            >
              {state.content.linkText}
            </a>
          </p>
          <p className="text-sm md:text-lg lg:text-xl py-2 text-secondary">
            {state.duration}
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Banner title="Works" />
      <div className="flex justify-center py-4">
        <div className="timeline-baseline" />
        <div className="timeline-container mr-2 my-4">
          {companies.map((state, idx) => (
            <TimelineState key={idx} state={state} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Works;
